export const schema = {
  batch: 'id notes updated_by',
  batch_material: 'id material updated_by',
  formula: 'id name amount unit_id product_id updated_by',
  formula_material:
    'id amount remark ordinal weight_percentage unit_id material_id updated_by',
  material: 'id name price density updated_by',
  product: 'id name code shortname updated_by',
  productList:
    'id name shortname code totalQc approvedQc qconlyQc pendingQc untestedQc',
  product_test_parameter:
    'id parameter coa ordinal specification_id updated_by',
  qc: 'id status updated_by',
  qc_test: 'id result updated_by', // used for testing data input
  unit: 'id name',
  user: 'id email firstname lastname enabled role updated_by',
};
